<template>
  <div id="app">
    <div id="loading-background">
      <div id="loading"></div>
    </div>
    <Menu v-if="!cTelaAssinarDocumento"/>
    <router-view/>
  </div>
</template>

<script>
import Menu from './components/Menu'

export default {
  name: 'App',

  components: {
    Menu,
  },

  data() {
    return {
      loading: false ,
    }
  },

  mounted() {
    this.$events.$on('loading', (payload) => {
      this.loading = payload
    })
  },

  watch: {
    loading() {
      const style = this.loading ? 'block' : 'none';
      document.getElementById('loading-background').style.display = style;
    },
  },

  computed: {
    cTelaAssinarDocumento() {
      return this.$route.name == 'AssinarDocumento'
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/app.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue